module.exports = __webpack_public_path__ + "img/number.5c26fe1f.gif";